import React, { Component } from 'react';
import Card from './Card';
import { CardProps } from '../../shared/Types';
import data from './../../data.json';

import './Cards.scss';

export default class Cards extends Component {
  render() {
    return (
      <div className="cards-container" data-testid="cards">
        {data.map((card: CardProps) => (
          <Card
            image={card.url}
            title={card.title}
            id={card.id}
            likes={card.likes}
            key={card.id}
            bookmarks={card.bookmarks}
            description={card.description}
          />
        ))}
      </div>
    );
  }
}
